import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { Toast } from './../UI/toast/Toast';
import { findOne, update } from '../../helpers/api/banks';
import { SUCCESS_RESPONSE } from '../../helpers/codeResponses/codes';
import handleErrorMessage from '../../helpers/errors/handleErrorMessage';
import PageHeader from '../common/PageHeader';
import CreateBankForm from './CreateBankForm';
import { PreloadState } from '../UI/preloading/PreloadState';
import SupportLink from '../root/support/components/SupportLink';
import { useHistory } from 'react-router-dom';

const EditBank = () => {

    const history = useHistory();

    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;
        const ac = new AbortController();
        (async () => {
            isMounted && setIsLoading(true);
            try {
                const { data } = await findOne(id, { signal: ac.signal });
                isMounted && setData(data);
            } catch (error) {
                handleErrorMessage(error);
            } finally {
                isMounted && setIsLoading(false);
            }
        })()
        return () => {
            ac.abort();
            isMounted = false;
        }
        // eslint-disable-next-line
    }, []);

    const { id } = useParams();

    if (!id || isNaN(id)) history.goBack();

    const handleEdit = async (values) => {
        try {
            const response = await update(id, values);
            if (response.code === SUCCESS_RESPONSE.OK) {
                Toast.fire({ type: 'success', title: `Se han guardado los cambios satisfactoriamente.` });
                history.push(`/dashboard/banks`);
            }
        } catch (error) {
            handleErrorMessage(error);
        }
    }

    return <>
        <PageHeader
            title={`Editar banco - ${data?.name || ''}`}
            titleTag="h2"
            description=""
            className="mb-3"
            col={{ lg: 9 }}
        >
            <SupportLink />
        </PageHeader>
        <PreloadState loading={isLoading} message='Cargando información del banco...'>
            <CreateBankForm bank={data} handleSubmitData={handleEdit} />
        </PreloadState>
    </>
}

export default EditBank;